import Rule from "../../../../../common/rule";
import FootballState from "../../../../state/football-state";
import DriveEndType from "../../../../enums/drive-end-type";

export default class FieldGoalGoodNotAffectedByPenalty extends Rule {
    constructor() {
        super();
        this.penaltyAcceptedFragment = null;
        this.kickFragment = null;
        this.fieldGoalFragment = null;
        this.isDefensivePenalty = false;
    }

    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        let apply = true;
        //
        if (fragment.associatedState === FootballState.FieldGoalGood) {
            this.kickFragment = play.getPreceedingFragment(
                fragment,
                FootballState.Kick
            );
            this.fieldGoalFragment = play.getFirstFragment(
                FootballState.FieldGoal
            );
            this.penaltyAcceptedFragment = play
                .getFragmentsBetween(fragment, [
                    FootballState.StatsCount,
                    FootballState.NoPlay
                ])
                .find(
                    ({ associatedState }) =>
                        associatedState === FootballState.PenaltyAccepted
                );

            this.isDefensivePenalty =
                this.penaltyAcceptedFragment &&
                this.penaltyAcceptedFragment?.causedBy?.teamId !==
                    this.kickFragment?.kickedBy?.teamId;

            apply = !this.penaltyAcceptedFragment || this.isDefensivePenalty;
        }

        return apply;
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { gameConfig } = gameContext;

        const isDropKick = this.fieldGoalFragment?.isDropKick === true;
        const driveEndType = isDropKick
            ? DriveEndType.DropKickFieldGoal
            : DriveEndType.FieldGoal;

        gameContext.setDriveContext({
            ...gameContext.getDriveContext(),
            previousDriveEndType: driveEndType
        });

        //Even though it's not affected by the penalty, we need to update the field position with the value in the penalty fragment
        if (this.penaltyAcceptedFragment) {
            gameContext.setFieldPosition(
                this.penaltyAcceptedFragment.fieldPosition
            );
        }

        if (!this.isDefensivePenalty) {
            // Check if this is a drop kick (Indoor Football) for adjusted scoring
            const isDropKick = this.fieldGoalFragment?.isDropKick === true;
            const points = isDropKick
                ? gameConfig.scoring.dropKickFieldGoal
                : gameConfig.scoring.fieldGoal;

            gameContext.increaseTeamPossessionScore(points);
            ruleContext.playPoints = points;
            ruleContext.setResetField(true);
            ruleContext.driveEnd = {
                isActive: true,
                endSpot: gameContext.getFieldPosition()
            };
        }
        ruleContext.setAwardFirstDown(true);
    }
}
